import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/frenos/icon/Close.svg")